import { useId, useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { LogoMark } from "@/components/Logo";

export default function GoldSeal({ size = 280 }) {
  const pathId = useId();
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const rx = useSpring(useTransform(my, [0, 1], [16, -16]), { stiffness: 120, damping: 14 });
  const ry = useSpring(useTransform(mx, [0, 1], [-16, 16]), { stiffness: 120, damping: 14 });

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width);
    my.set((e.clientY - r.top) / r.height);
  };
  const reset = () => {
    mx.set(0.5);
    my.set(0.5);
  };

  return (
    <div ref={ref} onMouseMove={onMove} onMouseLeave={reset} style={{ perspective: 900 }} className="select-none" data-testid="gold-seal-3d">
      <motion.div style={{ rotateX: rx, rotateY: ry, width: size, height: size }} className="relative">
        <svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full animate-spin-slow">
          <defs>
            <path id={pathId} d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" fill="none" />
          </defs>
          <text fill="#D4AF37" opacity="0.9" direction="ltr" style={{ fontSize: "10.5px", letterSpacing: "3px", fontFamily: "Arial, sans-serif", fontWeight: 700, direction: "ltr" }}>
            <textPath href={`#${pathId}`}>GM7 IMMIGRATION LAW GROUP • DR. MOHAMMAD AHMADI • EST. 2009 •</textPath>
          </text>
        </svg>
        <div className="absolute inset-0 m-auto flex h-[62%] w-[62%] items-center justify-center rounded-full border border-gold/40 bg-navy-900/85 shadow-[0_0_90px_rgba(212,175,55,0.18)] backdrop-blur">
          <LogoMark size={size * 0.14} />
        </div>
        <div className="absolute inset-[18%] m-auto rounded-full border border-gold/10" />
      </motion.div>
    </div>
  );
}
